<template>
	<div data-tour-scope="gift-card-list">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation="0">
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Gift Card</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>

						<v-col cols="12">
							<v-row data-tour="filters">
								<v-col cols="12" md="3">
									<v-text-field v-model="searchfield" label="Cerca" outlined append-icon="mdi-magnify" dense @click:append="getSearch" @keyup.enter="getSearch" hide-details></v-text-field>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dateCreatedMenu" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedCreatedAt" v-on="on" dense clearable @click:clear="clearCreatedAt" label="Data creazione" outlined hide-details></v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.created_at" @change="dateCreatedMenu = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-menu v-model="dateDeliveryMenu" :nudge-right="0" transition="scale-transition" offset-y min-width="290px" dense>
										<template v-slot:activator="{ on }">
											<v-text-field :value="computedDeliveryAt" v-on="on" dense clearable @click:clear="clearDeliveryAt" label="Data consegna" outlined hide-details></v-text-field>
										</template>
										<v-date-picker v-model="settings.filters.delivery_at" @change="dateDeliveryMenu = false" range></v-date-picker>
									</v-menu>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.sent"
										:items="[
											{ text: 'Inviata', value: true },
											{ text: 'Da inviare', value: false },
										]"
										multiple
										dense
										label="Invio"
										outlined
										hide-details
									></v-select>
								</v-col>
								<v-col cols="12" md="3">
									<v-select
										v-model="settings.filters.active"
										:items="[
											{ text: 'Attiva', value: true },
											{ text: 'Non attiva', value: false },
										]"
										multiple
										dense
										label="Stato wallet"
										outlined
										hide-details
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							data-tour="table"
							:headers="headers"
							:items="getWallets"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0 cellanowrap"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<!-- telefono: ogni riga diventa una card chiave/valore (lo slot body esiste solo su telefono, su desktop restano gli slot item.*) -->
							<template v-if="mobileCards" v-slot:body="{ items }">
								<tbody class="giftcard-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.Code || ''" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link :disabled="!orderId(item)" data-tour="row-order" @click="apriOrdine(item)">
																<v-list-item-title class="size9">Apri ordine</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-slot:top>
													<div class="d-flex flex-wrap mb-1" style="gap: 6px">
														<v-chip small data-tour="sent" :color="item.sent ? 'green' : 'orange'" dark>
															{{ item.sent ? 'Inviata' : 'Da inviare' }}
														</v-chip>
														<v-chip small data-tour="active" :color="item.active ? 'green' : 'grey'" dark>
															{{ item.active ? 'Attiva' : 'Non attiva' }}
														</v-chip>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="items.length === 0">
										<td :colspan="headers.length" class="grey--text text-center py-4">Nessun elemento</td>
									</tr>
								</tbody>
							</template>
							<template v-slot:[`item.menu`]="{ item }">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
											<v-icon dark>mdi-dots-vertical</v-icon>
										</v-btn>
									</template>
									<v-list>
										<v-list-item link :disabled="!orderId(item)" data-tour="row-order" @click="apriOrdine(item)">
											<v-list-item-title class="size9">Apri ordine</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</template>
							<template v-slot:item.created_at="{ item }">
								{{ item.created_at | moment('DD/MM/YYYY HH:mm:ss') }}
							</template>
							<template v-slot:[`item.order.OrderID`]="{ item }">
								{{ item.order && item.order.OrderID ? item.order.OrderID : '' }}
							</template>
							<template v-slot:item.buyer="{ item }">
								<div>{{ getBuyerName(item) }}</div>
								<small>{{ item.buyer && item.buyer.email ? item.buyer.email : '' }}</small>
							</template>
							<template v-slot:[`item.giftCard.email`]="{ item }">
								{{ item.giftCard && item.giftCard.email ? item.giftCard.email : '' }}
							</template>
							<template v-slot:[`item.giftCard.delivery_at`]="{ item }">
								<template v-if="item.giftCard && item.giftCard.delivery_at">
									{{ item.giftCard.delivery_at | moment('DD/MM/YYYY HH:mm:ss') }}
								</template>
							</template>
							<template v-slot:item.wallet="{ item }">
								{{ formatAmount(item) }}
							</template>
							<template v-slot:item.sent="{ item }">
								<v-chip small data-tour="sent" :color="item.sent ? 'green' : 'orange'" dark>
									{{ item.sent ? 'Inviata' : 'Da inviare' }}
								</v-chip>
							</template>
							<template v-slot:item.active="{ item }">
								<v-chip small data-tour="active" :color="item.active ? 'green' : 'grey'" dark>
									{{ item.active ? 'Attiva' : 'Non attiva' }}
								</v-chip>
							</template>
						</v-data-table>
					</v-card>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { listRouteState } from '@/components/core/list/listRouteState';
import { openWithReturn } from '@/components/core/pageReturn';
import { createGiftCardTourSteps } from './gift-card-tour';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'Wallet',
	components: { TourOverlay, KeyValueCard },
	// pagina, righe, ordinamento, ricerca e filtri stanno nell'URL: refresh e ritorno dall'ordine ripartono da li'
	mixins: [listRouteState({ filters: { created_at: 'array', delivery_at: 'array', sent: 'booleanArray', active: 'booleanArray' }, perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createGiftCardTourSteps()) };
	},
	data() {
		return {
			total: 0,
			listSize: LIST_SIZE,
			searchfield: '',
			dateCreatedMenu: '',
			dateDeliveryMenu: '',
			isMobile: false,
			// default, sovrascritti da quello che c'e' nell'URL
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {
					created_at: [],
					delivery_at: [],
					sent: [],
					active: [],
				},
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			}),
			headers: [
				// tre puntini con le azioni della riga
				{ text: '', value: 'menu', sortable: false, width: 50 },
				{ text: 'Data', value: 'created_at' },
				{ text: 'Ordine', value: 'order.OrderID' },
				{ text: 'Codice', value: 'Code' },
				{ text: 'Cliente', value: 'buyer', sortable: false },
				{ text: 'Beneficiario', value: 'giftCard.email' },
				{ text: 'Consegna', value: 'giftCard.delivery_at' },
				{ text: 'Importo', value: 'wallet' },
				{ text: 'Invio', value: 'sent' },
				{ text: 'Stato', value: 'active' },
			],
		};
	},
	computed: {
		...mapGetters({
			getWallets: 'giftcard/getGiftcards',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		computedCreatedAt() {
			return this.formatDateRange(this.settings.filters.created_at);
		},
		computedDeliveryAt() {
			return this.formatDateRange(this.settings.filters.delivery_at);
		},
	},
	mounted() {
		this.setExistFilter(true);
		this.listLoad();
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
			setExistFilter: 'settings/setExistFilter',
		}),
		...mapActions({
			fetchWallets: 'giftcard/asyncFetchData',
			destroyData: 'giftcard/destroyData',
		}),
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		formatDateRange(value) {
			if (!value || value.length === 0) {
				return '';
			}
			return value.map(date => moment(date).format('DD/MM/YYYY')).join(' ~ ');
		},
		clearCreatedAt() {
			this.settings.filters.created_at = [];
		},
		clearDeliveryAt() {
			this.settings.filters.delivery_at = [];
		},
		// il caricamento (e il ritorno a pagina 1) lo fa il mixin
		getSearch() {
			this.settings.search = (this.searchfield || '').length >= 3 ? this.searchfield : '';
		},
		orderId(item) {
			return item.order && item.order._id ? String(item.order._id) : '';
		},
		// la scheda ordine si apre come pagina e la freccia riporta qui, con la lista com'era
		apriOrdine(item) {
			const id = this.orderId(item);
			if (id) openWithReturn(this, { path: `/orders/${id}` }, { label: 'Torna alle Gift Card' });
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				const result = await this.fetchWallets(this.settings);
				this.total = result ? result.total : 0;
				this.setPreload(false);
			} catch (err) {
				this.setPreload(false);
				console.log(err);
			}
		},
		getBuyerName(item) {
			const name = item.buyer && item.buyer.name ? item.buyer.name : '';
			const lastname = item.buyer && item.buyer.lastname ? item.buyer.lastname : '';
			return `${name} ${lastname}`.trim();
		},
		formatAmount(item) {
			const amount = Number(item.wallet || 0).toFixed(2);
			return `${amount} ${item.Currency || ''}`.trim();
		},
		// coppie chiave/valore della card (vista telefono), stessi formati della tabella
		campiCard(item) {
			const data = v => (v ? this.$moment(v).format('DD/MM/YYYY HH:mm:ss') : '');
			const cliente = [this.getBuyerName(item), item.buyer && item.buyer.email ? item.buyer.email : ''].filter(Boolean).join(' - ');
			return [
				{ label: 'Importo', value: this.formatAmount(item), strong: true },
				{ label: 'Data', value: data(item.created_at) },
				{ label: 'Ordine', value: item.order && item.order.OrderID ? item.order.OrderID : '' },
				{ label: 'Cliente', value: cliente },
				{ label: 'Beneficiario', value: item.giftCard && item.giftCard.email ? item.giftCard.email : '' },
				{ label: 'Consegna', value: item.giftCard ? data(item.giftCard.delivery_at) : '' },
			];
		},
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.giftcard-cards,
.giftcard-cards tr {
	display: block;
	width: 100%;
}
.giftcard-cards tr,
.giftcard-cards tr:hover {
	background: transparent !important;
}
.giftcard-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
	/* la tabella ha cellanowrap: nelle card il testo deve andare a capo */
	white-space: normal !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.giftcard-cards tr:first-child td {
	padding-top: 12px !important;
}
.giftcard-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.giftcard-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
